import React, { useCallback } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import SupportRow from 'components/Onboarding/SupportRow';
import FeaturePageShell from 'components/shell/FeaturePageShell';
import { switchLanguage } from 'actions/App';
import { getSupportedLanguages } from 'components/LanguageSwitcher/data';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import styles from './AccountSettings.module.scss';

const AccountSettings = () => {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const { app } = useSelector((state) => state);
  const { locale } = app || {};
  const currentLocale = locale?.locale || 'en';

  const supportedLanguages = getSupportedLanguages();

  const handleLanguageChange = useCallback((event) => {
    const selectedLocale = event.target.value;
    const language = supportedLanguages.find((lang) => lang.locale === selectedLocale);
    if (language) {
      dispatch(switchLanguage(language));
    }
  }, [dispatch, supportedLanguages]);

  return (
    <FeaturePageShell
      title={localizeMessage('sidebar.account.settings')}
      description={localizeMessage('account.settings.description')}
      width="wide"
    >
      <section className={styles.settingsCard}>
        <div>
          <h2 className={styles.sectionTitle}>
            {localizeMessage('account.settings.language.title')}
          </h2>
          <p className={styles.sectionDescription}>
            {localizeMessage('account.settings.language.description')}
          </p>
        </div>
        <Select
          value={currentLocale}
          className={styles.languageSelect}
          inputProps={{
            'aria-label': localizeMessage('account.settings.language.title'),
          }}
          onChange={handleLanguageChange}
        >
          {supportedLanguages.map((language) => (
            <MenuItem key={language.languageId} value={language.locale}>
              {language.name}
            </MenuItem>
          ))}
        </Select>
      </section>

      <section className={styles.supportSection}>
        <div className={styles.supportHeader}>
          <h2 className={styles.sectionTitle}>
            {localizeMessage('account.settings.help.title')}
          </h2>
          <p className={styles.sectionDescription}>
            {localizeMessage('account.settings.help.description')}
          </p>
        </div>
        <SupportRow />
      </section>
    </FeaturePageShell>
  );
};

export default AccountSettings;
